module.exports = __webpack_public_path__ + "static/media/fun-games.f4175e50.webp";